import getPassedDays from './getPassedDays';

const formatDateToPassedDays = (date) => {
  const days = Math.floor(getPassedDays(date));
  return days === 0 ? 'today' : days === 1 ? 'day ago' : days >= 2 ? `${days} days ago` : '-';
};

export default formatDateToPassedDays;
